import { SsoConnectionUser } from '@choco-admin/types';
import { downloadCsv, toCsv } from '@choco-admin/utils';
import { Button, Tooltip } from '@heroui/react';
import React from 'react';
import { FiDownload } from 'react-icons/fi';

import { mappedValue } from '../../utils';

export interface ExportUsersButtonProps {
  users: SsoConnectionUser[];
  connectionName: string;
  isDisabled?: boolean;
}

const HEADERS = [
  'Email',
  'Last name',
  'First name',
  'Roles',
  'Locale',
  'Created',
  'Last modified',
];

/** Dates stay ISO 8601 so a spreadsheet reads them as dates, not text. */
const toRow = (user: SsoConnectionUser): Record<string, string> => ({
  Email: user.email ?? '',
  'Last name': mappedValue(user, 'family_name') ?? '',
  'First name': mappedValue(user, 'given_name') ?? '',
  Roles: user.federatedRoles.join('; '),
  Locale: mappedValue(user, 'locale') ?? '',
  Created: user.createdAt ?? '',
  'Last modified': user.lastModifiedAt ?? '',
});

export const ExportUsersButton: React.FC<ExportUsersButtonProps> = ({
  users,
  connectionName,
  isDisabled = false,
}) => {
  const handleExport = () => {
    const csv = toCsv({ headers: HEADERS, rows: users.map(toRow) });
    const date = new Date().toISOString().slice(0, 10);

    downloadCsv({
      filename: `sso-users-${connectionName}-${date}.csv`,
      csv,
    });
  };

  return (
    <Tooltip
      content="Exports every user on this connection. Search and role filters do not change the file."
      placement="top"
    >
      <Button
        size="sm"
        variant="flat"
        color="primary"
        startContent={<FiDownload />}
        isDisabled={isDisabled}
        onPress={handleExport}
      >
        Export all to CSV
      </Button>
    </Tooltip>
  );
};
